import React from "react"
import { Table } from "react-bootstrap"
import { formatCurrency } from "../../lib/utils"
import CaptionTable from "../fragments/CaptionTable"

export default function OtherCostsTable({ commissionFee, transportFee }) {

  return (
    <Table striped condensed hover responsive>

      <CaptionTable text='Other costs' />

      <tbody>
        <tr>
          <th>Commission fee</th>
          <th>Transport fee</th>
          <th>Total</th>
        </tr>
        <tr>
          <td>{ formatCurrency(commissionFee) }</td>
          <td>{ formatCurrency(transportFee) }</td>
          <td>{ formatCurrency(commissionFee + transportFee) }</td>
        </tr>
      </tbody>
    </Table>
  )
}



// WEBPACK FOOTER //
// ./src/components/Financiers/OtherCostsTable.js